import { useGetUserData } from "./useGetUserData"
import { Datasets } from "../constants/enums"

/**
 * Hook for giving permissions to users based on their role for the LCT
 * and TTR webpahes
 * @returns {object} - object with boolean values for each action that can be performed
 */
export const useGetLctTtrRbac = (
    deviceRef: string,
    dataset?: Datasets
): {
    canPublishDevice: boolean
    canReadAlerts: boolean
    canRaiseAlerts: boolean
    canDeleteAlert: (username: string | null) => boolean
    canReadComments: boolean
    canCreateComments: boolean
    canPinComments: boolean
} => {
    const isTTRDataset =
        !dataset || dataset === Datasets.TTR || dataset === Datasets.TTR_DRAFT

    const {
        isEnaSysAdmin,
        isManuAdmin,
        isDnoAdmin,
        isDemandAssessor,
        isGenAssessor,
        isManuApproved,
        isDnoApproved,
        username,
        isManufacturerForDevice,
    } = useGetUserData()

    const isAssessor = isTTRDataset ? isGenAssessor : isDemandAssessor

    const canReadAlerts =
        isEnaSysAdmin ||
        ((isManuAdmin || isManuApproved) &&
            isManufacturerForDevice(deviceRef)) ||
        isDnoApproved ||
        isDnoAdmin ||
        isAssessor ||
        isDnoApproved

    const canRaiseAlerts =
        isEnaSysAdmin ||
        (isManuAdmin && isManufacturerForDevice(deviceRef)) ||
        isDnoAdmin

    const canDeleteAlert = (alerterUsername: string | null): boolean =>
        isEnaSysAdmin ||
        (isDnoAdmin && !!alerterUsername && username === alerterUsername)

    const canPublishDevice = isEnaSysAdmin || isManuApproved

    const canReadComments =
        isEnaSysAdmin ||
        ((isManuAdmin || isManuApproved) &&
            isManufacturerForDevice(deviceRef)) ||
        isDnoAdmin ||
        isDnoApproved ||
        isAssessor

    const canCreateComments =
        isEnaSysAdmin ||
        ((isManuAdmin || isManuApproved) &&
            isManufacturerForDevice(deviceRef)) ||
        isDnoAdmin ||
        isDnoApproved ||
        isAssessor

    const canPinComments = isAssessor || isEnaSysAdmin

    return {
        canPublishDevice,
        canReadAlerts,
        canRaiseAlerts,
        canDeleteAlert,
        canReadComments,
        canCreateComments,
        canPinComments,
    }
}
